angular.module('bmsApp.settings')
	.controller('SMHouseTemplateSaveCtrl', [
		'$log',
		'$state',
		'$scope',
		'$q',
		'notify',
		'SMCleaningServiceSvc',
		'SMHouseTemplateSvc',
		function ($log,
				  $state,
				  $scope,
				  $q,
				  notify,
				  SMCleaningServiceSvc,
				  SMHouseTemplateSvc) {

			function init() {
				self.updating = $state.is('main.settings.smHouseTemplatesIndex.update') ? true : false;

				var promises = {};

				if (self.updating) {
					angular.extend(promises, {
						houseTemplate: SMHouseTemplateSvc.read($state.params.houseTemplateId)
					});

					$q.all(promises)
						.then(function (responses) {
							self.houseTemplate = responses.houseTemplate.data.house_template;
							self.loading = false;
						});
				}


			}

			function addCleaningService() {
				SMCleaningServiceSvc.showCleaningServiceModal(null)
					.then(function (result) {
						angular.extend(result.cleaningService,{
							accepted: true,
							satisfied: true,
						});
						self.houseTemplate.cleaning_services.push(result.cleaningService);
					});
			}

			function editCleaningService(item) {
				SMCleaningServiceSvc.showCleaningServiceModal(item)
					.then(function (result) {
						angular.extend(item, result.cleaningService);
					});
			}

			function deleteCleaningService(item) {
				if (item.added) {
					self.houseTemplate.cleaning_services.splice(self.houseTemplate.cleaning_services.indexOf(item), 1);
				}
				else {
					angular.extend(item, {
						delete: true
					});
				}
			}

			function undoDeleteCleaningService(item) {
				angular.extend(item, {
					delete: false
				});
			}

			function submit() {
				if (self.formValidator.valid()) {
					SMHouseTemplateSvc.save(self.houseTemplate)
						.then(function (response) {
							notify({
								message: 'Successfully saved'
							});
							$state.go('main.settings.smHouseTemplatesIndex');
						}, function(errors) {
							self.errors = errors;
						});
				}
			}

			var self = $scope.SMHouseTemplateSaveCtrl = {
				loading: false,
				processing: false,
				formvalidatorconfig: {},
				formValidator: {},
				houseTemplate: {
					cleaning_services: []
				},
				options: {},
				methods: {
					init: init,
					submit: submit,
					addCleaningService: addCleaningService,
					editCleaningService: editCleaningService,
					deleteCleaningService: deleteCleaningService,
					undoDeleteCleaningService: undoDeleteCleaningService
				}
			};

		}
	]);
